export default __webpack_public_path__ + "static/media/ib-icon-active.d474b8a8.svg";